import { useTranslation } from "react-i18next";

import { IPatient } from "../../../../../../@types/Patient";
import {
  AccordionList,
  AccordionListItem,
  AccordionListItemDefaultContent,
} from "../../../../../../components/AccordionList";
import { AlertsCounter } from "../../../../../../components/AlertsCounter";
import { useFlagPatient } from "../../../../../../hooks/mutations/patients";
import { mobileAccordionListColumns } from "../../tableColumns";
import { FlagPatientButton } from "../FlagPatientButton/FlagPatientButton";
import { AccordionTitleButton, EmptyStateContainer } from "./MobileList.style";

type IMobileListProps = {
  data: IPatient[];
  emptyStateText?: string;
  onRowClick: (rowContent: any) => void;
};

export function MobileList({
  data,
  onRowClick,
  emptyStateText,
}: IMobileListProps) {
  const { t } = useTranslation();
  const haveData = Boolean(data && data.length);
  const mutate = useFlagPatient();

  if (!haveData) {
    return (
      <EmptyStateContainer>
        <p>{emptyStateText || t("common_noDataToShow")}</p>
      </EmptyStateContainer>
    );
  }

  // TODO: Virtualize this accordion list in the future
  return (
    <AccordionList type="single" collapsible>
      {data.map((patient: any, index) => {
        return (
          <AccordionListItem
            key={`${patient.id}_${index}`}
            index={index + 2} // Adding +2 to start the list with gray color
            title={
              <AccordionTitleButton
                onClick={(event) => {
                  event.stopPropagation();

                  onRowClick(patient);
                }}
              >
                {patient.name}
              </AccordionTitleButton>
            }
            value={`patient-list-${index}`}
            subtitle={t("patientList_mobile_lastUsed", {
              lastUsed: patient.lastUsed,
            })}
            headerComponents={
              <div style={{ display: "flex", alignItems: "center" }}>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: "130px",
                  }}
                >
                  {patient.alerts !== "-" ? (
                    <AlertsCounter>
                      {
                        patient.alerts.props.children.props.children.props
                          .children
                      }
                    </AlertsCounter>
                  ) : (
                    "-"
                  )}
                </div>
                <FlagPatientButton
                  onClick={(e) => {
                    e.stopPropagation();
                    mutate({
                      patientId: patient.id,
                      flagged: !patient.flagged,
                    });
                  }}
                  isMobile
                  flagged={patient.flagged}
                />
              </div>
            }
          >
            <AccordionListItemDefaultContent
              content={patient}
              columns={mobileAccordionListColumns}
            />
          </AccordionListItem>
        );
      })}
    </AccordionList>
  );
}
